import { Button } from '@artstorefronts/ui';
import { HelpCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAnalytics } from '~/context/analytics';

export function SupportButton() {
  const { t } = useTranslation('nav');
  const { intercom } = useAnalytics();

  return (
    <Button variant="ghost" size="sm" onClick={() => intercom.show()} className="rounded-full gap-1">
      <HelpCircle className="w-4 h-4" />
      {t('support')}
    </Button>
  );
}
